module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row margin-b10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "plain-box"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.rodosol) ? _c('div', {
    staticClass: "col-md-4 small-padding-right",
    class: _vm.type != 'newContract' ? 'col-md-4' : 'col-md-6'
  }, [_c('div', {
    staticClass: "second-col"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "fourty-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (_vm.newAhesionTaxMan > 0) ? _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("\n                " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxMan)) + "\n              ")]) : _c('span', [_c('h4', {
    staticClass: "promo-value"
  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
    staticClass: "promo-free"
  }, [_vm._v("Grátis")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row-button"
  }, [_c('button', {
    staticClass: "btn btn-default btn-large",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.choose(31)
      }
    }
  }, [_vm._v("\n                Quero este plano!\n              ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 small-padding-left small-padding-right",
    class: _vm.type != 'newContract' ?
      _vm.rodosol ?
      'col-md-12' :
      'col-md-4' :
      'col-md-6'
  }, [_c('div', {
    staticClass: "third-col"
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "fourty-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (_vm.newAhesionTaxMan > 0) ? _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("\n                " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxMan)) + "\n              ")]) : _c('span', [_c('h4', {
    staticClass: "promo-value"
  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
    staticClass: "promo-free"
  }, [_vm._v("Grátis")])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "row-button"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.choose(32)
      }
    }
  }, [_vm._v("\n                Quero este plano!\n              ")])])])]), _vm._v(" "), (_vm.type != 'newContract' && !_vm.rodosol) ? _c('div', {
    staticClass: "col-md-4 small-padding-left"
  }, [_c('div', {
    staticClass: "fourth-col"
  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "fourty-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Adesão por Veículo")]), _vm._v(" "), (_vm.newAhesionTaxMan > 0) ? _c('h3', {
    staticClass: "bold no-margin"
  }, [_vm._v("\n                " + _vm._s(_vm._f("cents")(_vm.newAhesionTaxMan)) + "\n              ")]) : _c('span', [_c('h4', {
    staticClass: "promo-value"
  }, [_vm._v("R$ 39,90")]), _vm._v(" "), _c('b', {
    staticClass: "promo-free"
  }, [_vm._v("Grátis")])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "row-button"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "to": {
        name: 'request-proposal',
        query: {
          plano: 'Frota'
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Quero este plano!\n              ")])], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('card-taxes', {
    attrs: {
      "showTaxes": 'pj'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 first-col"
  }, [_c('div', {
    staticClass: "first-line border-radius-top"
  }, [_c('p', {
    staticClass: "margin-10"
  }, [_c('i', {
    staticClass: "icon-plans icon-plans-table"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "second-line"
  }, [_c('p', {
    staticClass: "text-question"
  }, [_vm._v("A quem se destina?")])]), _vm._v(" "), _c('div', {
    staticClass: "third-line"
  }, [_c('p', {
    staticClass: "text-question"
  }, [_vm._v("Como Funciona?")])]), _vm._v(" "), _c('div', {
    staticClass: "fourty-line"
  }, [_c('p', {
    staticClass: "text-question"
  }, [_vm._v("Adesão por Veículo")])]), _vm._v(" "), _c('div', {
    staticClass: "sixty-line"
  }, [_c('p', {
    staticClass: "text-question"
  }, [_vm._v("Formas de Pagamento")])]), _vm._v(" "), _c('div', {
    staticClass: "eighty-line"
  }, [_c('p', {
    staticClass: "text-question"
  }, [_vm._v("Sujeito à análise de crédito?")])]), _vm._v(" "), _c('div', {
    staticClass: "seventy-line"
  }, [_c('p', {
    staticClass: "text-question"
  }, [_vm._v("Pode receber Vale-pedágio?")])]), _vm._v(" "), _c('div', {
    staticClass: "ninety-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-line"
  }, [_c('h3', {
    staticClass: "sub-title plan upper"
  }, [_vm._v("Controle")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Pré-pago com recarga manual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "second-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("\n                Empresas que querem controle total dos seus gastos e querem\n                planejar as recargas.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "third-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', [_vm._v("\n                O próprio cliente efetua a recarga, escolhendo um dos valores\n                disponíveis ou qualquer valor acima de R$ 2.000,00*. Sem taxa\n                de mensalidade. Créditos não expiram. Sem caução."), _c('br'), _vm._v("\n                Saldo compartilhado por todos os veículos."), _c('br'), _vm._v("\n                Disponível no app e no site.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixty-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', {
    staticClass: "payment-list"
  }, [_c('li', [_vm._v("Cartão de Crédito")]), _vm._v(" "), _c('li', [_vm._v("Pix")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eighty-line"
  }, [_c('p', [_vm._v("Plano não está sujeito à análise de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Não")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seventy-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-line"
  }, [_c('h3', {
    staticClass: "sub-title plan upper"
  }, [_vm._v("Estradeiro")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Pré-pago com recarga automática")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "second-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("\n                Empresas que querem a certeza de sempre ter saldo disponível\n                para uso.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "third-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', [_vm._v("\n                As recargas ocorrem automaticamente, quando o saldo atingir\n                30% do valor que o cliente escolher ou definir acima de R$\n                2.000,00*. Ex.: Cliente escolhe R$ 500,00. Quando o saldo\n                chegar a R$ 150,00, uma nova recarga é acionada\n                automaticamente."), _c('br'), _vm._v("\n                Sem taxa de mensalidade. Créditos não expiram. Sem caução."), _c('br'), _vm._v("\n                Saldo compartilhado por todos os veículos."), _c('br'), _vm._v("\n                Disponível no app e no site.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixty-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', {
    staticClass: "payment-list"
  }, [_c('li', [_vm._v("Cartão de Crédito")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eighty-line"
  }, [_c('p', [_vm._v("Plano não está sujeito à análise de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Não")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seventy-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-line"
  }, [_c('h3', {
    staticClass: "sub-title plan upper"
  }, [_vm._v("Frota")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Pós-pago com mensalidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "second-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("\n                Empresas que precisam da confiabilidade do serviço e da\n                tranquilidade financeira.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "third-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', [_vm._v("\n                O cliente conta com uma linha de crédito para pagamento pós\n                uso e a facilidade de prever o custo por meio de mensalidades\n                fixas. A fatura será emitida em prazos pré-definidos. Sem\n                custo de recarga."), _c('br'), _vm._v("\n                Disponível no site.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sixty-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', {
    staticClass: "payment-list"
  }, [_c('li', [_vm._v("Débito Automático")]), _vm._v(" "), _c('li', [_vm._v("Boleto Bancário")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eighty-line"
  }, [_c('p', [_vm._v("Plano está sujeito à análise de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seventy-line"
  }, [_c('p', {
    staticClass: "mob-title-info"
  }, [_vm._v("Pode receber Vale-pedágio?")]), _vm._v(" "), _c('p', [_vm._v("Sim")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-52106e5c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/plans/b2b.vue
// module id = 2127
// module chunks = 1